import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { useSelectedDealer } from "components";
import { createFormHelper } from "lib/Form";
import { ASTERISK_PLACEHOLDER } from "modules/DealerOverviewDashboard/components";

import type { DealerOverviewFormPayload } from "modules/DealerOverviewDashboard/hooks";

const FormHelper = createFormHelper<DealerOverviewFormPayload>();

export const Xentry = () => {
  const { t } = useTranslation();
  const { watch, setValue } = FormHelper.useFormContext();

  const { selectedDealer } = useSelectedDealer();
  const isXentryEnabled = watch("is_xentry_enabled");

  const clearXentryFields = (checked: boolean) => {
    if (checked) return;
    setValue("xentry_client_id", "");
    setValue("xentry_client_secret", "");
  };

  return (
    <>
      <div className="dealer-overview-subheading">{t("v8_xentry", "Xentry")}</div>
      <FormHelper.Field.Checkbox name="is_xentry_enabled" label={t("v8_xentry_enabled", "Xentry Enabled")} onChange={clearXentryFields} />
      {isXentryEnabled && (
        <Form.Group>
          <Form.Field width={8}>
            <label>{t("v8_xentry_client_id", "Xentry client ID")}</label>
            <FormHelper.Field.Input
              name="xentry_client_id"
              preventAutofill
              inputProps={{ type: "password", placeholder: selectedDealer?.has_kms_encrypted_xentry_client_id ? ASTERISK_PLACEHOLDER : "" }}
            />
          </Form.Field>
          <Form.Field width={8}>
            <label>{t("v8_xentry_client_secret", "Xentry client secret")}</label>
            <FormHelper.Field.Input
              name="xentry_client_secret"
              preventAutofill
              inputProps={{ type: "password", placeholder: selectedDealer?.has_kms_encrypted_xentry_client_secret ? ASTERISK_PLACEHOLDER : "" }}
            />
          </Form.Field>
        </Form.Group>
      )}
    </>
  );
};
